import { LoginService } from './login.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/auth.service';
import { EncryptionProviderService } from '@shared/encryption.service';
import { ToastrService } from 'ngx-toastr';
import { LoginData } from './login.model';
import { Something_went_wrong } from '@root/app.constant';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;

  constructor(
    public router: Router,
    public authService: AuthService,
    public encryptionProviderService: EncryptionProviderService,
    private loginService: LoginService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    const isLoggedIn = AuthService.isLoggedIn();
    if(isLoggedIn){
      this.loginService.logout().subscribe(
        data=>{
          this.authService.logout();
      });
    }
  }

  processForm = () => {
    const loginData: LoginData = {
      userName: this.username,
      password: this.encryptionProviderService.encryptData(this.password),
    };

    this.loginService.login(loginData).subscribe(
      (response) => {
        if (response.status === 0) {
          this.authService.login(response.data);
        } else {
          this.toastr.error(response.error.errorMessage);
        }
      },
      (error) => {
        if (error.errorMessage == null) {
          this.toastr.error(Something_went_wrong);
        } else {
          this.toastr.error(error.errorMessage);
        }
      }
    );
  };
}
